// extracted by mini-css-extract-plugin
export default {"qrCode":"S6PmPxKNlDG1rVPESAGR"};